import { useEffect } from 'react';
export default (function (effect) {
  useEffect(effect, []);
});